import * as z from "zod";

export const addCustomerProductLicenseFormSchema = z.object({
  // License
  no_of_licenses: z.preprocess(
    (val) => {
      {
        if (val === null || val === undefined || val === "") return undefined;
        const num = Number(val);
        return isNaN(num) ? val : num;
      }
    },
    z.number()
      .min(1, "Number of licenses must be at least 1.")
      .refine(val => !isNaN(val), "Please enter a valid number for licenses.")
  )
});


export type AddCustomerProductLicenseFormValues = z.infer<typeof addCustomerProductLicenseFormSchema>;